module.exports = "<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/components/mainarea/mainarea.component.html
// module id = ../../../../../src/app/modules/ui-base/components/mainarea/mainarea.component.html
// module chunks = main